module.exports = __webpack_public_path__ + "static/media/023.50c9efe6.jpg";